import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";

const PRIORITY_CLASS = {
  low: "border-slate-300 text-slate-700",
  medium: "border-slate-500 text-slate-900",
  high: "border-[#F97316] text-[#F97316] bg-orange-50",
  urgent: "border-[#DC2626] text-[#DC2626] bg-red-50",
};

const STATUS_CLASS = {
  pending: "bg-[#EAB308] text-slate-900",
  accepted: "bg-[#0033A0] text-white",
  completed: "bg-[#16A34A] text-white",
  rejected: "bg-slate-500 text-white",
};

export default function Referrals() {
  const [items, setItems] = useState([]);
  const load = async () => { const { data } = await api.get("/referrals"); setItems(data); };
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    await api.patch(`/referrals/${id}`, { status });
    load();
  };

  return (
    <div className="p-8 md:p-10 max-w-[1600px] mx-auto">
      <div className="overline">Network</div>
      <h1 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight mt-2 mb-8">Referrals</h1>

      <div className="border border-slate-200">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50">
              <th className="p-4 text-left overline">Case</th>
              <th className="p-4 text-left overline">From</th>
              <th className="p-4 text-left overline">To Org</th>
              <th className="p-4 text-left overline">Priority</th>
              <th className="p-4 text-left overline">Status</th>
              <th className="p-4 text-left overline">Reason</th>
              <th className="p-4 text-left overline">Action</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={7} className="p-8 text-center text-slate-500">No referrals yet.</td></tr>}
            {items.map(r => (
              <tr key={r.id} data-testid={`referral-${r.id}`} className="border-b border-slate-100 align-top">
                <td className="p-4"><Link to={`/cases/${r.case_id}`} className="text-[#0033A0] font-mono text-xs underline">{r.case_id}</Link></td>
                <td className="p-4 text-xs">{r.from_email}<div className="text-slate-400">{r.from_organization || "—"}</div></td>
                <td className="p-4"><div className="font-semibold">{r.to_organization}</div><div className="text-xs text-slate-500">{r.to_user_email || "—"}</div></td>
                <td className="p-4"><span className={`inline-block px-2 py-1 text-[10px] font-bold uppercase tracking-wider border ${PRIORITY_CLASS[r.priority]}`}>{r.priority}</span></td>
                <td className="p-4"><span className={`inline-block px-2 py-1 text-[10px] font-bold uppercase tracking-wider ${STATUS_CLASS[r.status]}`}>{r.status}</span></td>
                <td className="p-4 max-w-[240px] text-slate-600">{r.reason}</td>
                <td className="p-4">
                  {r.status === "pending" && (
                    <div className="flex gap-2">
                      <button data-testid={`accept-${r.id}`} onClick={() => setStatus(r.id, "accepted")} className="border border-[#0033A0] text-[#0033A0] px-3 py-1 text-xs hover:bg-[#0033A0] hover:text-white">Accept</button>
                      <button onClick={() => setStatus(r.id, "rejected")} className="border border-slate-300 px-3 py-1 text-xs hover:bg-slate-900 hover:text-white">Reject</button>
                    </div>
                  )}
                  {r.status === "accepted" && (
                    <button onClick={() => setStatus(r.id, "completed")} className="border border-[#16A34A] text-[#16A34A] px-3 py-1 text-xs hover:bg-[#16A34A] hover:text-white">Complete</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
